import { render, staticRenderFns } from "./image-classifier.component.html?vue&type=template&id=1470c0f2&scoped=true&external"
import script from "./image-classifier.component.vue?vue&type=script&lang=ts"
export * from "./image-classifier.component.vue?vue&type=script&lang=ts"
import style0 from "./image-classifier.component.css?vue&type=style&index=0&id=1470c0f2&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1470c0f2",
  null
  
)

export default component.exports